<template>
    <div class="projects-page">
        <div class="container">
            <div class="page-title">
                <h1 v-if="currentProjectPageType == 'built'">{{pageSetup.built_page_title}}</h1>
                <h1 v-if="currentProjectPageType == 'construction'">{{pageSetup.construction_page_title}}</h1>
                <h1 v-if="currentProjectPageType == 'international'">{{pageSetup.international_page_title}}</h1>
                <h1 v-if="currentProjectPageType == 'promising'">{{pageSetup.promising_page_title}}</h1>
                <projectsFilter :currentProjectPage="currentProjectPageType" v-if="currentProjectPageType != 'international'"></projectsFilter>
            </div>
            <projectItems :projectItems="projectItems" :page="currentProjectPageType"></projectItems>

            <transition
                name="fade"
                mode="out-in"
            >
                <div class="btn-pagination" v-if="projectItemsCounter.count_current < projectItemsCounter.count_max">
                    <a href="#" @click.prevent="paginationItems">
                        <span v-if="globalLang == ''">Загрузить еще</span>
                        <span v-if="globalLang == 'kz/'">Көбірек жүктеңіз</span>
                        <span v-if="globalLang == 'en/'">Load more</span>
                    </a>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import projectItems from '@/components/projects/project-item.vue'
    import projectsFilter from '@/components/projects/project-filter.vue'
    export default {
        name: 'page--built',
        components: {
            projectItems,
            projectsFilter,
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                currentProjectPageType: 'built',
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            pageSetup: 'loadProjectsPage',
            projectItems: 'loadProjectItems',
            projectItemsCounter: 'loadProjectItemsCounter',
            projectFilterData: 'loadProjectFilterData',
        }),
        methods: {
            paginationItems() {
                this.$store.commit('projectItemsSetCountDef', this.projectItemsCounter.count_current + 1);
                const urlDef = this.currentProjectPageType + '/?per_page=9' + '&page=' + this.projectItemsCounter.count_current;
                const urlFilter = this.currentProjectPageType + '?project_type=' + this.projectFilterData.filter_id + '&per_page=9' + '&page=' + this.projectItemsCounter.count_current;;
                if (this.projectFilterData.filter_slug != 'all') {
                    this.$parent.$refs.topProgress.start();
                    this.$store.dispatch('getProjectItemsByParam', {url : urlFilter, type: 'pagintaion'}).then((response) => {
                        if (response) {this.$parent.$refs.topProgress.done()} else {this.$parent.$refs.topProgress.fail();}
                    });
                } else {
                    this.$parent.$refs.topProgress.start();
                    this.$store.dispatch('getProjectItemsByParam', {url : urlDef, type: 'pagintaion'}).then((response) => {
                        if (response) {this.$parent.$refs.topProgress.done()} else {this.$parent.$refs.topProgress.fail();}
                    });
                }
                console.log(this.projectItemsCounter.count_current)
                console.log(this.projectItemsCounter.count_max)
                // console.log(this.projectFilterData, 'asdasdasdsad');
            },  
        },
        beforeRouteEnter (to, from, next) {
            // console.log(to, 'asdadasdass')
            store.dispatch('getProjectItemsList', to.name).then((response) => {
                // console.log(resp, 'HOME')
                if (response) {
                    next(vm => {
                        vm.currentProjectPageType = to.name;
                        vm.$store.commit('removePageLoaderImg');
                        vm.$parent.$refs.topProgress.done()
                    });
                } else {
                    next(false, vm => vm.$parent.$refs.topProgress.fail());
                }
            });
        },
        beforeCreate() {
            document.body.dataset.page = 'projects-page';
        },
        created () {
            // document.title = this.titlePage + ' - ' + this.titleSite;
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/projects/projects-page.scss';
    @import '@/styles/components/projects/respond/projects-page-respond.scss';
    // @import '@/styles/respond/projects/pages/default-page-respond.scss';
</style>